<template>
    <div>
        <div class="download">
            <a :href='downloadhttp' download="" title="下载">说明:上传前请先点此链接下载云对象例表</a><i class="el-icon-download"></i>
        </div>
        <el-upload class="upload-demo" drag name="excel_file" :on-success="upload_sucess" :on-error="upload_error" :action="upload_url" :headers="upload_header">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过1M</div>
        </el-upload>
        <el-button type="text" @click="pageToList">查看和管理对象-></el-button>
    </div>
</template>
<script>
import axios from 'axios';
import { Button } from 'iview'
import config from '../../config.js';
export default {
    components: {
        Button
    },
    props: ['group_id', 'from'],
    data() {
        return {
            group: {
                group_id: ''
            },
            upload_url: '',
            upload_header: {
                Authorization: null
            },

        }
    },
    created() {
        //console.log(this.group_id)
        this.group.group_id = this.group_id
        this.upload_header.Authorization = localStorage.getItem('token')
        this.downloadhttp = config.base_url + '/yun_duixiang/download/index'
        this.upload_url = config.base_url + '/yun_table/yun_duixiang/upload?group_id=' + this.group.group_id
    },
    methods: {

        upload_sucess(response) {
            if (this.from == 'yunduixiang') {
                this.$alert('云对象上传例表.xlxs上传成功，请点击确定到显示对象菜单中查看修改', '上传成功', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$router.push({
                            name: 'duixianglists',
                            params: {
                                group_id: this.group.group_id
                            }
                        })
                    }
                });
            }
            if (this.from == 'yunjiancha') {
                this.$alert('云对象上传例表.xlxs上传成功，请点击确定继续操作', '上传成功', {
                    confirmButtonText: '确定',
                    callback: action => {
                        //this.show = true
                    }
                });
            }
        },
        upload_error(err) {
            this.$message.error('文件格式或大小不符合要求');
        },
        pageToList() {
            this.$router.push({
                name: 'duixianglists',
                params: {
                    group_id: this.group.group_id
                }
            })
            

        }
    }

}
</script>
<style>
/*.download a{
    color: #fff;
}*/
.download a {
    color: teal;
    text-decoration: none;
    display: inline-block;
    margin-bottom: 30px;
    margin-top: 30px;
}

.download a:visited {
    text-decoration: none;
}

.download a:hover {
    color: #ba2636;
    text-decoration: none;
}

.download a:active {
    color: #ba2636;
}
</style>